import {LoaderFunction} from "react-router-dom";
import {MyCoursesCourseCardDto} from "@/routes/myCourses/types/myCoursesCourseCardDto.ts";
import {apiEndpoints} from "@/services/api/api.ts";

export const myCoursesLoader: LoaderFunction =
    async (): Promise<MyCoursesCourseCardDto[]> => {
        try {
            const response = await apiEndpoints.getMyCourses();
            if (response.success)
                return response.data as MyCoursesCourseCardDto[];
            return [] as MyCoursesCourseCardDto[];
        } catch (error) {
            throw new Error(error instanceof Error ? error.message : "Unknown error");
        }
    };